import axios from "axios";

const getEffectiveContractComments = async function () {
  try {
    const res = await axios.get(`/eff_contract/eff_contract_comments`);
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

const getEffectiveContractComment = async function (effContractCommentId) {
  try {
    const res = await axios.get(`/eff_contract/eff_contract_comments/${effContractCommentId}`);
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

const createEffectiveContractComment = async function (personEffContractId, content) {
  try {
    const res = await axios.post(`/eff_contract/eff_contract_comments`, {
      eff_contract_comment: {content: content, person_eff_contract_id: personEffContractId}
    });
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

const updateEffectiveContractComment = async function (personEffContractId, effContractCommentId, content) {
  try {
    const res = await axios.put(`/eff_contract/eff_contract_comments/${effContractCommentId}`, {
      eff_contract_comment: {content: content, person_eff_contract_id: personEffContractId}
    });
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

const deleteEffectiveContractComment = async function (effContractCommentId) {
  try {
    const res = await axios.delete(`/eff_contract/eff_contract_comments/${effContractCommentId}`);
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

export {
  getEffectiveContractComments,
  getEffectiveContractComment,
  createEffectiveContractComment,
  updateEffectiveContractComment,
  deleteEffectiveContractComment,
}